<template>
  <div class="mobile-badges">
    <button @click="showMobileOrders = true" class="badge-btn orders">
      <span class="badge-icon">📋</span>
      <span class="badge-count">{{ restaurantTables.filter((e) => !isEmpty(e.orders)).length }}</span>
    </button>
    <button @click="showMobileDeliveries = true" class="badge-btn deliveries">
      <span class="badge-icon">🚚</span>
      <span class="badge-count" v-if="deliveries.length > 0">{{ deliveries.length }}</span>
    </button>
    <button
      @click="showMobileNotifications = true"
      class="badge-btn notifications"
    >
      <span class="badge-icon">🔔</span>
      <span class="badge-count" v-if="notifications.length > 0">{{ notifications.length }}</span>
    </button>
  </div>
  <div
    v-if="showMobileOrders"
    class="mobile-modal"
    @click="showMobileOrders = false"
  >
    <div class="mobile-panel" @click.stop>
      <div class="mobile-header">
        <h3>Orders</h3>
        <button @click="showMobileOrders = false" class="close-btn">✕</button>
      </div>
      <div class="mobile-content">
        <div v-if="restaurantTables.length === 0" class="empty-state">
          <div class="empty-icon">📋</div>
          <p>There are no orders</p>
        </div>
        <div v-else class="orders-list">
          <template
            v-for="item in restaurantTables.filter((e) => !isEmpty(e.orders))"
            :key="item.id"
          >
            <div
              class="grid grid-cols-4 gap-2 flex-shrink-0 bg-gray-50 dark:bg-gray-900 p-3 rounded-lg relative"
              tabindex="0"
            >
              <div class="col-span-2">
                <h4 class="font-medium text-gray-900 dark:text-white truncate">
                  {{ item.table_number }}
                </h4>
              </div>
              <div class="text-right min-w-[80px]">
                {{ formatNumber(item.orders?.total_amount) }}
              </div>
              <div
                class="text-right min-w-[80px] px-5 flex gap-1 justify-center"
              >
                <Buttons
                  size="sm"
                  type="info"
                  icon="Eye"
                  @click="viewOrder(item)"
                  caption=""
                />
                <Buttons
                  size="sm"
                  type="success"
                  icon="Banknote"
                  @click="makeBill(item)"
                  caption=""
                />
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="showMobileNotifications"
    class="mobile-modal"
    @click="showMobileNotifications = false"
  >
    <div class="mobile-panel" @click.stop>
      <div class="mobile-header">
        <h3>Notifications</h3>
        <button @click="showMobileNotifications = false" class="close-btn">
          ✕
        </button>
      </div>
      <div class="mobile-content">
        <div v-if="notifications.length === 0" class="empty-state">
          <div class="empty-icon">🔔</div>
          <p>No new notifications</p>
        </div>
        <div v-else class="notifications-list">
        </div>
      </div>
    </div>
  </div>

  <div
    v-if="showMobileDeliveries"
    class="mobile-modal"
    @click="showMobileDeliveries = false"
  >
    <div class="mobile-panel" @click.stop>
      <div class="mobile-header">
        <h3>Deliveries</h3>
        <button @click="showMobileDeliveries = false" class="close-btn">
          ✕
        </button>
      </div>
      <div class="mobile-content">
        <div v-if="deliveries.length === 0" class="empty-state">
          <div class="empty-icon">🚚</div>
          <p>No pending deliveries</p>
        </div>
        <div v-else class="deliveries-list">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { RestaurantTables } from "../../../../../types/models";
import { formatNumber, isEmpty } from "../../../../../utils/CommonFunctions";
import Buttons from "../../../../../components/ui/form/Buttons.vue";

const emit = defineEmits<{
  (e: "show-bill", table: RestaurantTables): void;
  (e: "make-bill", table: RestaurantTables): void;
}>();



defineProps<{
  restaurantTables: RestaurantTables[];
  //notifications: any[],
  //deliveries: any[]
}>();

const viewOrder = (table: RestaurantTables) => {
    showMobileOrders.value = false;
    showMobileNotifications.value = false;
    showMobileDeliveries.value = false;
  emit('show-bill', table)
};


const makeBill = (table: RestaurantTables) => {
    showMobileOrders.value = false;
    showMobileNotifications.value = false;
    showMobileDeliveries.value = false;
  emit("make-bill", table);
};

const showMobileOrders = ref(false);
const showMobileNotifications = ref(false);
const showMobileDeliveries = ref(false);

const notifications = ref([]);

const deliveries = ref([]);

</script>

<style scoped>
.mobile-badges {
  display: none;
  margin-top: 3rem;
}

.success-modal {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.success-content {
  background: white;
  border-radius: 1rem;
  padding: 2rem;
  text-align: center;
  max-width: 400px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.success-icon {
  width: 4rem;
  height: 4rem;
  background: #10b981;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: 700;
  margin: 0 auto 1.5rem;
}

.success-content h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 1rem 0;
}

.success-content p {
  font-size: 0.875rem;
  color: #6b7280;
  margin: 0.5rem 0;
}

.btn-ok {
  margin-top: 1.5rem;
  padding: 0.75rem 2rem;
  background: #2563eb;
  color: white;
  border: none;
  border-radius: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-ok:hover {
  background: #1d4ed8;
}

.mobile-modal {
  display: none;
}

@media (max-width: 1024px) {
  .mobile-badges {
    display: flex;
    gap: 0.75rem;
    position: fixed;
    top: 1rem;
    right: 1rem;
    z-index: 100;
  }

  .badge-btn {
    position: relative;
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 50%;
    border: none;
    background: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }

  .badge-btn:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }

  .badge-btn:active {
    transform: scale(0.95);
  }

  .badge-icon {
    font-size: 1.5rem;
  }

  .badge-count {
    position: absolute;
    top: -0.25rem;
    right: -0.25rem;
    background: #ef4444;
    color: white;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    font-weight: 700;
    border: 2px solid white;
  }

  .mobile-modal {
    display: flex;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 200;
    align-items: flex-start;
    justify-content: flex-end;
    padding: 1rem;
  }

  .mobile-panel {
    background: white;
    border-radius: 1rem;
    width: 100%;
    max-width: 400px;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.2);
    animation: slideIn 0.3s ease-out;
  }

  @keyframes slideIn {
    from {
      transform: translateX(100%);
      opacity: 0;
    }
    to {
      transform: translateX(0);
      opacity: 1;
    }
  }

  .mobile-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.25rem 1.5rem;
    border-bottom: 1px solid #e5e7eb;
  }

  .mobile-header h3 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: #1f2937;
  }

  .close-btn {
    background: none;
    border: none;
    font-size: 1.5rem;
    color: #6b7280;
    cursor: pointer;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.375rem;
    transition: all 0.2s;
  }

  .close-btn:hover {
    background: #f3f4f6;
    color: #1f2937;
  }

  .mobile-content {
    flex: 1;
    overflow-y: auto;
    padding: 1.5rem;
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 200px;
    color: #9ca3af;
    text-align: center;
  }

  .empty-icon {
    font-size: 4rem;
    margin-bottom: 1rem;
    opacity: 0.5;
  }

  .empty-state p {
    font-size: 0.875rem;
    margin: 0;
  }

  .orders-list,
  .notifications-list,
  .deliveries-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .order-card,
  .notification-card,
  .delivery-card {
    padding: 1rem;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
  }

  .order-header,
  .delivery-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.75rem;
  }

  .order-number,
  .delivery-number {
    font-weight: 700;
    color: #1f2937;
    font-size: 0.875rem;
  }

  .order-status,
  .delivery-status {
    padding: 0.25rem 0.625rem;
    border-radius: 0.25rem;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
  }

  .order-status.pending,
  .delivery-status.preparing {
    background: #fef3c7;
    color: #92400e;
  }

  .order-status.preparing {
    background: #dbeafe;
    color: #1e40af;
  }

  .order-status.ready {
    background: #d1fae5;
    color: #065f46;
  }

  .delivery-status.in-transit {
    background: #dbeafe;
    color: #1e40af;
  }

  .order-details {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .order-info {
    display: flex;
    justify-content: space-between;
    font-size: 0.8125rem;
  }

  .label {
    color: #6b7280;
    font-weight: 500;
  }

  .amount {
    font-weight: 700;
    color: #059669;
  }

  .notification-card {
    display: flex;
    gap: 0.75rem;
    align-items: flex-start;
  }

  .notification-icon {
    font-size: 1.5rem;
    flex-shrink: 0;
  }

  .notification-content {
    flex: 1;
    min-width: 0;
  }

  .notification-message {
    margin: 0 0 0.25rem 0;
    font-size: 0.875rem;
    color: #1f2937;
    font-weight: 500;
  }

  .notification-time {
    font-size: 0.75rem;
    color: #9ca3af;
  }

  .delivery-details {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }

  .delivery-address {
    margin: 0;
    font-size: 0.8125rem;
    color: #4b5563;
  }

  .delivery-time {
    margin: 0;
    font-size: 0.75rem;
    color: #6b7280;
    font-weight: 500;
  }
}

@media (max-width: 768px) {
  .mobile-badges {
    top: 0.75rem;
    right: 0.75rem;
    gap: 0.5rem;
  }

  .badge-btn {
    width: 3rem;
    height: 3rem;
  }

  .badge-icon {
    font-size: 1.25rem;
  }

  .badge-count {
    width: 1.25rem;
    height: 1.25rem;
    font-size: 0.625rem;
  }

  .mobile-panel {
    max-width: 100%;
  }
}
</style>
